import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardButtonsCont, CardNavButton, Wrapper } from './QuestionsPaginator.styles';
import { OpenQuestionsFieldsType } from '../../../../../services/reports';

interface QuestionsPaginatorProps {
  data: OpenQuestionsFieldsType[];
  onChange: (id: number) => void;
}

const QuestionsPaginator: React.FC<QuestionsPaginatorProps> = ({ data, onChange }) => {
  const [isActive, setIsActive] = useState(0);

  const { t } = useTranslation();

  const handleSwitchTab = (index: number) => () => {
    setIsActive(index);
    onChange(index);
  };
  return (
    <Wrapper>
      {data.map((item, index) => {
        const active = isActive === index;
        return (
          <CardButtonsCont key={item.code} onClick={handleSwitchTab(index)}>
            <CardNavButton active={active}>{`${t('report.effect.table.open')} ${
              index + 1
            }`}</CardNavButton>
          </CardButtonsCont>
        );
      })}
    </Wrapper>
  );
};

export default QuestionsPaginator;
